import { Button } from "@material-ui/core";
import T from "i18n-react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { renderFormInsertVar, renderVarsListToInsert } from "../../vars/utility";
import {
    changeCurrentValue,
    disableFlagInsertVar,
    disableFlagVars,
    enableFlagInsertVar,
    insertStaplingVarsAPI,
    insertVarsAPI,
    operatorViewSelector,
    setArticleToWaste
} from "../slice";
import DialogOperator from "../utility/DialogOperator";
import { opViewStyles } from "../utility/customStyles";

const VarsDialog = ({ configuration }) => {
    const customClasses = opViewStyles();
    const dispatch = useDispatch();
    const { currentValue, choosenVar, vars, loading, flagDialog, odp, operator, machine, process, modeStapling, staplingList,
        articleToWaste, staplingArticles, modeMaintenance } = useSelector(operatorViewSelector);

    //Aggiornamento dello proprietà current value tramite Input field
    const handleChangeValueText = (event) => {
        dispatch(changeCurrentValue({ value: event.target.value }));
    };
    //viene valorizzato lo stato currentValue che rappresnta il valore della var di tipo boolean
    const handleChangeValueBool = (event, value) => {
        dispatch(changeCurrentValue({ value: value }));
    };
    //button che seleziona la variable scelta per l inserimento
    const handleChooseVar = (varChoosen) => {
        dispatch(enableFlagInsertVar(varChoosen))
    };
    //API che inserisci la variabile usando il current value
    const handleInsertVar = () => {
        dispatch(insertVarsAPI(odp, process, choosenVar, currentValue, operator, machine, false, false, false, false))
    };
    //API che inserisci la variabile per una pinatura usando il current value
    const handleInsertStaplingVar = () => {
        dispatch(insertStaplingVarsAPI(odp, choosenVar, currentValue, operator, machine, articleToWaste, false, false, false, false))
    };

    const onChangeArticleAutocomplete = (name, value, reason) => {
        if (reason === "clear") {
            dispatch(setArticleToWaste({ articles: false, value: false }))
        } else {
            dispatch(setArticleToWaste({ articles: staplingArticles, value: value.id }))
        }
    };
    const renderListVarsActions = () => {
        return (
            <Button className={customClasses.dialogButton} disabled={loading} variant="contained" onClick={() => dispatch(disableFlagVars())} color="secondary">{T.translate("button.close")}</Button>
        )
    }

    const renderInsertVarActions = () => {
        return (
            <React.Fragment>
                <Button className={customClasses.dialogButton} variant="contained" onClick={!modeStapling ? handleInsertVar : handleInsertStaplingVar}
                    color="primary"
                    disabled={currentValue === null || currentValue === "" || loading || (
                        !articleToWaste && choosenVar && modeStapling && choosenVar.operatorEdit && choosenVar.operatorView && staplingList && choosenVar.name === staplingList[0].type.rejectedPieces
                    )}>
                    {T.translate("button.confirm")}
                </Button>
                <Button className={customClasses.dialogButton} disabled={loading} variant="contained" onClick={() => dispatch(disableFlagInsertVar())}
                    color="secondary">{T.translate("button.back")}
                </Button>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            {/*Dialog per elencare le variabili da inserire*/}
            <DialogOperator flag={flagDialog.flagVars ? true : false} title={!modeMaintenance ? T.translate("processType.var.listVariables") : T.translate("maintenance.declarationsList")}
                form={() => renderVarsListToInsert(true, vars, handleChooseVar, configuration.decimals)}
                actions={() => renderListVarsActions()} transparentBackround={false} />
            {/*Dialog per inserire una determinata variabili scelta dal dialog precedente*/}
            <DialogOperator flag={flagDialog.flagInsertVar ? true : false} title={!modeMaintenance ? T.translate("processType.var.insertVariable") : T.translate("maintenance.insertDeclaration")}
                form={() => renderFormInsertVar(choosenVar, currentValue, handleChangeValueText, handleChangeValueBool, loading,
                    choosenVar && modeStapling && choosenVar.operatorEdit && choosenVar.operatorView && staplingList && choosenVar.askArticle ? staplingArticles : false, articleToWaste, onChangeArticleAutocomplete)}
                actions={() => renderInsertVarActions()} transparentBackround={false} />
        </React.Fragment >
    )
}

export default VarsDialog;
